export default __webpack_public_path__ + "static/media/douyin.bb8e9167.jpg";